/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { integrationSchema } from './integrationSchema';

export const instanceWithIntegrationsSchema = z.object({
  createdAt: z.iso.datetime(),
  id: z.int(),
  instanceId: z.string(),
  instanceName: z.string(),
  instanceUrl: z.string(),
  get integrations() {
    return z.array(integrationSchema);
  },
  updatedAt: z.iso.datetime(),
});
